"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ToolbarButton", {
    enumerable: true,
    get: function() {
        return ToolbarButton;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactbutton = require("@fluentui/react-button");
const _useToolbarButtonStylesstyles = require("./useToolbarButtonStyles.styles");
const _useToolbarButton = require("./useToolbarButton");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const ToolbarButton = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useToolbarButton.useToolbarButton_unstable)(props, ref);
    (0, _useToolbarButtonStylesstyles.useToolbarButtonStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useToolbarButtonStyles_unstable')(state);
    return (0, _reactbutton.renderButton_unstable)(state);
// Casting is required due to lack of distributive union to support unions on @types/react
});
ToolbarButton.displayName = 'ToolbarButton';
